import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type PaperClipIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const PaperClipIcon = ({
  size = 18,
  color,
  colorScheme = 'dark',
  className,
}: PaperClipIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Attach'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 18 19'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.9486 8.80185L9.29028 16.4602C8.35208 17.3984 7.0796 17.9255 5.75278 17.9255C4.42596 17.9255 3.15348 17.3984 2.21528 16.4602C1.27708 15.522 0.75 14.2495 0.75 12.9227C0.75 11.5959 1.27708 10.3234 2.21528 9.38519L9.87361 1.72685C10.4991 1.10138 11.3474 0.75 12.2319 0.75C13.1165 0.75 13.9648 1.10138 14.5903 1.72685C15.2157 2.35232 15.5671 3.20064 15.5671 4.08519C15.5671 4.96973 15.2157 5.81805 14.5903 6.44352L6.92361 14.1019C6.61088 14.4146 6.18672 14.5903 5.74445 14.5903C5.30217 14.5903 4.87801 14.4146 4.56528 14.1019C4.25255 13.7891 4.07685 13.365 4.07685 12.9227C4.07685 12.4804 4.25255 12.0563 4.56528 11.7435L11.6403 4.67685'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
